import React, { useEffect, useRef, useState } from 'react';
import { Typography } from 'antd';

const { Text } = Typography;

/**
 * Small count-up number, inspired by reactbits.dev's CountUp block — trimmed to a single
 * dependency-free component so a stat card doesn't just "pop in" as a static number.
 */
const CountUpStat = ({ value, label, duration = 900 }) => {
  const [display, setDisplay] = useState(0);
  const frameRef = useRef(null);

  useEffect(() => {
    const target = Number(value) || 0;
    const start = performance.now();
    const tick = (now) => {
      const progress = Math.min(1, (now - start) / duration);
      const eased = 1 - (1 - progress) ** 3;
      setDisplay(Math.round(target * eased));
      if (progress < 1) frameRef.current = requestAnimationFrame(tick);
    };
    frameRef.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frameRef.current);
  }, [value, duration]);

  return (
    <div style={{ textAlign: 'center' }}>
      <div style={{ fontSize: 40, fontWeight: 700, color: '#005EB8', lineHeight: 1.1 }}>
        {display.toLocaleString()}
      </div>
      <Text type="secondary" style={{ fontSize: 15 }}>{label}</Text>
    </div>
  );
};

export default CountUpStat;
